import React, { Component } from 'react';

class FilterPriority extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: '',
            isOpened: false
        }
    }

    handleSelect = data => {
        this.setState({
            selected: data,
            isOpened: false
        })
        this.props.handleChange(data)
    }

    handleDropdown = e => {
        if (this.dropdownRef && !this.dropdownRef.current.contains(e.target)) {
            this.setState({
                isOpened: false
            })
        }
    }

    render() {
        return (
            <div className="text-sm">
                {
                    this.props.data !== undefined && this.props.data.map((data, idx) =>
                        <div className="dropdown-list__item" key={idx} id="btnfilterpriority" onClick={() => this.handleSelect(data)}>
                            {
                                this.state.selected.value === data.value ?
                                    <div className="pt-3 pl-5 pr-5 bg-blue-200">
                                        <div className="pb-3 flex justify-between items-center border-b-2 border-gray capitalize">
                                            <div>{data.label}</div>
                                        </div>
                                    </div>
                                    :
                                    <div className="pt-3 pl-5 pr-5 hover:bg-blue-100">
                                        <div className="pb-3 flex justify-between items-center border-b-2 border-gray capitalize">
                                            <div>{data.label}</div>
                                        </div>
                                    </div>
                            }
                        </div>
                    )
                }
            </div>
        );
    }
}

export default FilterPriority;